import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const eldbooksConfig: TSPConfig = {
  key: 'eldbooks',
  name: 'ELDBooks',
  imageName: 'eldbooks',
  category: TSPCategory.API_KEY,
  helpText: 'Enter your ELDBooks API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default eldbooksConfig;
